import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { DragulaModule } from 'ng2-dragula';
import { PopoverModule } from 'ngx-smart-popover';
import { AppCommonModule } from '../app-common.module';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { InvoicesRoutingModule } from './invoices-routing.module';
import { UploadInvoicesCoverSheetComponent } from './upload-invoices/upload-invoices-cover-sheet/upload-invoices-cover-sheet.component';
import { UploadInvoicesFooterComponent } from './upload-invoices/upload-invoices-footer/upload-invoices-footer.component';
import { UploadInvoicesOptionsComponent } from './upload-invoices/upload-invoices-options/upload-invoices-options.component';
import { UploadInvoicesThumbnailPreviewComponent } from './upload-invoices/upload-invoices-thumbnail-preview/upload-invoices-thumbnail-preview.component';
import { UploadInvoicesZoneComponent } from './upload-invoices/upload-invoices-zone/upload-invoices-zone.component';
import { UploadInvoicesComponent } from './upload-invoices/upload-invoices.component';
import { InvoiceDetailService } from './invoice-detail/invoice-detail.service';

@NgModule({
    imports: [
        AppCommonModule,
        LsqCommonModule.forChild(),
        LsqTablesModule.forChild(),
        InvoicesRoutingModule,
        DragulaModule.forRoot(),
        PopoverModule
    ],
    declarations: [
        InvoiceDetailComponent,
        UploadInvoicesComponent,
        UploadInvoicesOptionsComponent,
        UploadInvoicesZoneComponent,
        UploadInvoicesThumbnailPreviewComponent,
        UploadInvoicesFooterComponent,
        UploadInvoicesCoverSheetComponent
    ],
    providers: [InvoiceDetailService]
})
export class InvoicesModule {}
